import { Breadcrumb } from "@chakra-ui/react";
import { Link } from "react-router-dom";

interface BreadcrumbComponentProps {
  data: {
    title: string;
    href?: string | null;
  }[];
}

function BreadcrumbComponent({ data }: BreadcrumbComponentProps) {
  return (
    <Breadcrumb.Root mb={6}>
      <Breadcrumb.List>
        {data.map((item, index) => (
          <Breadcrumb.Item key={index}>
            {!item.href ? (
              <Breadcrumb.CurrentLink>{item.title}</Breadcrumb.CurrentLink>
            ) : (
              <Breadcrumb.Link asChild>
                <Link to={item.href}>{item.title}</Link>
              </Breadcrumb.Link>
            )}
            {index < data.length - 1 && <Breadcrumb.Separator />}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb.List>
    </Breadcrumb.Root>
  );
}

export default BreadcrumbComponent;
